import {EnvironmentModel, IOHURLS} from "./environment.model";
import {Endpoints} from "./endpoints";

export const IOH: IOHURLS = {
  patientServiceBaseURL: 'https://portal.iohealthtech.com',
  userServiceBaseURL: 'https://portal.iohealthtech.com',
  cdsServiceBaseUrl: 'https://portal.iohealthtech.com',
  rulesServiceBaseUrl: 'https://portal.iohealthtech.com',
  reportsServiceBaseUrl: 'https://portal.iohealthtech.com',
}

const endpoints = new Endpoints()
export const environment: EnvironmentModel= {
  production: false,
  posthogApiKey: 'ioh-client-telemetry',
  telemetryEnabled: false,
  cognito: {
    userPoolId: 'us-east-2_jSqJgpb76',
    userPoolWebClientId: '7tdv91p6bvl4jv446kbgcu1abo',
    region: 'us-east-2',
    accessTokenExpiryMinutes: 60,
    refreshTokenExpiryMinutes: 30 * 24 * 60, // 30 days
    sso: {
      domain: 'ioh-pool-prod.auth.us-east-2.amazoncognito.com',
      identityProvider: 'ioh-prod-idp-oidc',
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    },
  },
  endPoints: { ...endpoints.getGenericEndpoints()},
  awsCredentials: {
    region: "us-east-2",
    signatureVersion: "v4"
  }
}
